import { Component } from 'react';

interface ErrorBoundaryProps {
  children: JSX.Element;
}

interface ErrorBoundaryState {
  error?: Error;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override readonly state: ErrorBoundaryState = {};

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override render() {
    const { error } = this.state;

    if (error) {
      // eslint-disable-next-line no-console -- We display full error to console instead of just showing message to user
      console.error(error);

      // We don't want to render anything
      return null;
    }

    const { children } = this.props;

    return children;
  }
}
